module.exports = __webpack_public_path__ + "static/media/t10.ae7c28d1.jpg";